"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {

    props: ["dico", "currentFarm"],

    data: function data() {
        return {};
    },


    methods: {
        open: function open() {
            window.$(this.$el).toggleClass("open");
        },
        getFarmPortrait: function getFarmPortrait(path) {
            return window.GLOBAL_CONFIG.baseUploadUrl.replace('__path__', path);
        }
    },

    computed: {
        currentPortrait: function currentPortrait() {
            return this.getFarmPortrait(this.currentFarm.config.infos.portrait_image);
        }
    },

    mounted: function mounted() {

        if (window.GLOBAL_CONFIG.isShop) {
            setInterval(function () {
                window.location.href = window.$(".select-menu__options a:eq(0)").attr("href");
            }, 120000);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/select-menu/SelectMenuComponent.vue
// module id = 401
// module chunks = 0